import { ReactNode } from 'react';
import { TooltipProvider } from '@/components/ui/tooltip';

interface AuthenticatedLayoutProps {
  children: ReactNode;
}

/**
 * Layout wrapper for authenticated routes.
 * 
 * This component provides:
 * - TooltipProvider: Deferred from initial bundle since /auth page has no tooltips
 * 
 * NOTE: Auth routes intentionally do NOT have TooltipProvider.
 * If future features need tooltips on Auth pages, wrap locally:
 * <TooltipProvider><YourComponent /></TooltipProvider>
 */
export function AuthenticatedLayout({ children }: AuthenticatedLayoutProps) {
  return (
    <TooltipProvider>
      {children}
    </TooltipProvider>
  );
}
